import { has } from 'lodash';

export const isTraining = (timelineItem) => has(timelineItem, 'training_type');
